import { Image } from 'expo-image'
import { StyleSheet, View } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import { useColorScheme } from '@/hooks/useColorScheme'
import { useOrgBySlug } from '@/hooks/useOrgBySlug'
import { getOrgLogoUrl } from '@/lib/file-upload'

interface OrgHeadingProps {
    orgSlug: string
}

export function OrgHeading({ orgSlug }: OrgHeadingProps) {
    const theme = useTheme()
    const colorScheme = useColorScheme()
    const { org } = useOrgBySlug(orgSlug)
    const isDark = colorScheme === 'dark'

    if (!org) return null

    const logoUrl = getOrgLogoUrl(org.id, org.logo)

    return (
        <View style={styles.container}>
            {logoUrl ? (
                <View style={[styles.logoContainer, isDark && styles.logoContainerDark]}>
                    <Image source={{ uri: logoUrl }} style={styles.logo} contentFit="contain" />
                </View>
            ) : (
                <Text
                    variant="headlineMedium"
                    style={[styles.orgName, { color: theme.colors.onSurface }]}
                    numberOfLines={2}
                >
                    {org.name}
                </Text>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        alignItems: 'center',
    },
    logoContainer: {
        width: '100%',
    },
    logoContainerDark: {
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: 8,
        padding: 8,
    },
    logo: {
        width: '100%',
        minHeight: 70,
    },
    orgName: {
        fontWeight: '600',
        textAlign: 'center',
    },
})
